<template>
    <div class="providerSectionAdminReport">
        <div :style="`z-index: 9999; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiChartBox }}
            </v-icon>
            <span>Reports</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto; position: relative;"
        >
            <v-card-title style="padding: 15px 0 5px 0">
                <v-row no-gutters>
                    <v-col cols="10">
                        <v-card style="padding: 0 10px; margin: 0">
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="frDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="FR DATE"
                                        :disabled="loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="toDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="TO DATE"
                                        :disabled="loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-select
                                        v-model="requestType"
                                        :disabled="loading"
                                        dense
                                        hide-details
                                        outlined
                                        color="teal darken-1 white--text"
                                        item-text="name"
                                        :items="[{name: 'Consultation', value: 'C'}, {name: 'Diagnostics Procedure', value: 'O'}]"
                                        label="TYPE"
                                    />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="2" style="margin: 0; padding: 0; position: relative;">
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    :disabled="loading"
                                    style="min-width: 0; width: 10px; padding: 17px 21px; right: 55%; position: absolute;"
                                    color="teal darken-1 white--text"
                                    v-on="on"
                                    @click="getData(currentItem, {FR_DATE: frDate, TO_DATE: toDate, TYPE_T: requestType, MSU_C: filter.acu.msu, ACCT_N: filter.acu.acctN, MEMB_N: filter.acu.membN})"
                                >
                                    <v-icon>{{ mdiReload }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Apply Filters</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    :disabled="loading"
                                    style="min-width: 0; width: 10px; padding: 17px 21px; right: 11%; position: absolute;"
                                    color="teal darken-1 white--text"
                                    v-on="on"
                                    @click="downloadReportProvider()"
                                >
                                    <v-icon>{{ mdiDownload }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Download Excel Report</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-title style="margin: 0; padding: 20px 7px">
                <v-row class="search-filter-transition-row">
                    <!-- Search Column -->
                    <v-col
                        :cols="filter.acu.status ? 3 : 11"
                        class="search-filter-search-column"
                        :class="{ 'search-filter-compressed': filter.acu.status }"
                    >
                        <v-text-field
                            v-model="searchQuery"
                            style="width: 100%;"
                            dense
                            hide-details
                            :disabled="loading"
                            color="teal darken-1"
                            :append-icon="mdiMagnify"
                            clearable
                            label="Search"
                            class="search-filter-main-input"
                            @click:append="search=searchQuery"
                            @keydown.enter="search=searchQuery"
                            @click:clear="search=''"
                        />
                    </v-col>
                    <v-col
                        :cols="filter.acu.status ? 9 : 1"
                        class="search-filter-columns-container"
                        :class="{ 'search-filter-expanded': filter.acu.status }"
                    >
                        <v-row class="search-filter-inner-row">
                            <transition name="search-filter-slide" mode="out-in">
                                <v-col v-if="filter.acu.status" cols="4" class="search-filter-field-col search-filter-field-1">
                                    <v-text-field
                                        v-model="filter.acu.msu"
                                        hide-details
                                        color="teal darken-1"
                                        dense
                                        label="MSU Code"
                                        placeholder="000"
                                        clearable
                                        :disabled="loading"
                                        @click:clear="handleRunFilter('filter.acu.msu')"
                                        @keyup.enter="handleRunFilter()"
                                    />
                                </v-col>
                            </transition>
                            <transition name="search-filter-slide" mode="out-in">
                                <v-col v-if="filter.acu.status" cols="4" class="search-filter-field-col search-filter-field-2">
                                    <v-text-field
                                        v-model="filter.acu.acctN"
                                        hide-details
                                        color="teal darken-1"
                                        dense
                                        label="Account Number"
                                        placeholder="00000"
                                        clearable
                                        :disabled="loading"
                                        @click:clear="handleRunFilter('filter.acu.acctN')"
                                        @keyup.enter="handleRunFilter()"
                                    />
                                </v-col>
                            </transition>
                            <transition name="search-filter-slide" mode="out-in">
                                <v-col v-if="filter.acu.status" cols="3" class="search-filter-field-col search-filter-field-3">
                                    <v-text-field
                                        v-model="filter.acu.membN"
                                        hide-details
                                        color="teal darken-1"
                                        dense
                                        label="Member Number"
                                        placeholder="000000"
                                        clearable
                                        :disabled="loading"
                                        class="search-filter-field-input"
                                        @click:clear="handleRunFilter('filter.acu.membN')"
                                        @keyup.enter="handleRunFilter()"
                                    />
                                </v-col>
                            </transition>
                            <v-col
                                v-if="!filter.acu.status"
                                style="position: absolute; right: 10px; top: 70px;"
                                cols="1"
                            >
                                <v-tooltip top>
                                    <template #activator="{ on }">
                                        <v-btn
                                            elevation="2"
                                            color="success white--text"
                                            :disabled="loading"
                                            icon
                                            v-on="on"
                                            @click="filter.acu.status = true"
                                        >
                                            <v-icon>{{ mdiFilterPlus }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Add Filter</span>
                                </v-tooltip>
                            </v-col>
                            <v-col
                                v-else
                                style="position: absolute; right: 10px; top: 70px;"
                                cols="1"
                            >
                                <v-tooltip top>
                                    <template #activator="{ on }">
                                        <v-btn
                                            elevation="2"
                                            color="error white--text"
                                            :disabled="loading"
                                            icon
                                            v-on="on"
                                            @click="handleRemoveFilter"
                                        >
                                            <v-icon>{{ mdiFilterRemove }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remove Filter</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-subtitle style="margin-top: -24px; height: 40px; padding: 0">
                <v-tabs
                    v-model="currentItem"
                    slider-size="3"
                    style="margin-top: 7px;"
                    slider-color="teal darken-1"
                    grow
                    color="teal darken-1"
                    height="40"
                >
                    <v-tab
                        v-for="item in items"
                        :key="item"
                        :disabled="loading"
                        :href="'#tab-' + item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </v-card-subtitle>
            <v-tabs-items v-model="currentItem">
                <v-tab-item
                    v-for="(itemTab, index) in items"
                    :key="itemTab"
                    :transition="false"
                    :value="'tab-' + itemTab"
                    style="margin: 0; padding: 0; position: relative;"
                >
                    <span
                        v-if="currentItem === 'tab-APPROVAL LOGS' && data && data.length > 0"
                        style="background-color: white; color: #666; position: absolute; z-index: 10; right: 0; top: 0; height: 31.80px; width: 78px; border-radius: 0 5px 0 0; text-align: center; font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600; padding-top: 5px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    >Action</span>
                    <span
                        v-if="currentItem === 'tab-LOGIN LIST' && data && data.length > 0"
                        style="background-color: white; color: #666; position: absolute; z-index: 10; right: 0; top: 0; height: 31.80px; width: 122px; border-radius: 0 5px 0 0; text-align: center; font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600; padding-top: 5px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    >ACTION</span>
                    <v-data-table
                        :ref="`dataTabletest_${index}`"
                        :search="search"
                        :loading="loading ? '#009688' : null"
                        dense
                        :items="data"
                        :headers="modifiedHeaders"
                        :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50, 100],
                            'items-per-page-text': ''
                        }"
                        :class="`${currentItem === 'tab-APPROVAL LOGS' || currentItem === 'tab-LOGIN LIST' ? data && data.length > 0 ? 'approvalTbl' : '' : ''} providerReportTbl`"
                        fixed-header
                        @pagination="onPaginationChange"
                    >
                        <template #item="{ item }">
                            <tr>
                                <td
                                    v-for="(key, indexHeader) in modifiedHeaders"
                                    :key="indexHeader"
                                    style="white-space: nowrap;"
                                >
                                    {{ item[key.value] }}
                                </td>
                                <td v-if="currentItem === 'tab-APPROVAL LOGS'">
                                    <v-tooltip
                                        top
                                        style="z-index: 100;"
                                    >
                                        <template #activator="{ on }">
                                            <v-btn
                                                :disabled="loading"
                                                style="min-width: 0; padding: 0 10px; margin: 0"
                                                color="teal darken-1"
                                                class="white--text"
                                                v-on="on"
                                                @click="downloadOpan(item)"
                                            >
                                                <v-icon>{{ mdiDownload }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Download Approval</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="currentItem === 'tab-LOGIN LIST'">
                                    <div style="width: 90px; margin: 0; padding: 0;">
                                        <v-tooltip
                                            top
                                            style="z-index: 20;"
                                        >
                                            <template #activator="{ on }">
                                                <v-btn
                                                    :disabled="loading"
                                                    style="min-width: 0; padding: 0 10px; margin: 0"
                                                    color="warning"
                                                    class="white--text"
                                                    v-on="on"
                                                    @click="UpdateAccountFunc(item)"
                                                >
                                                    <v-icon>{{ mdiPencil }}</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Update Account</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            top
                                            style="z-index: 20;"
                                        >
                                            <template #activator="{ on }">
                                                <v-btn
                                                    :disabled="loading"
                                                    style="min-width: 0; padding: 0 10px; margin: 0"
                                                    color="red darken-1"
                                                    class="white--text"
                                                    v-on="on"
                                                    @click="disableAccountFunc(item)"
                                                >
                                                    <v-icon>{{ mdiAccountCancel }}</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Deactivate Account</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <DisableAccount
            :show="show.disable.status"
            :data="show.disable.data"
            @closeDialog="show.disable.status = false"
        />
        <UpdateAccount
            :show="show.update.status"
            :data="show.update.data"
            @closeDialog="show.update.status = false"
        />
    </div>
</template>

<script>
import UpdateAccount from './UpdateAccount.vue'
import DisableAccount from './DisableAccount.vue'
import { saveAs } from 'file-saver'
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiChartBox,
    mdiReload,
    mdiDownload,
    mdiFilterPlus,
    mdiFilterRemove,
    mdiPencil,
    mdiAccountCancel,
    mdiMagnify
} from '@mdi/js'
import { base64ToBlob } from '../../../../utils/helpers'
export default {
    components: { DisableAccount, UpdateAccount },
    data () {
        return {
            mdiChartBox,
            mdiReload,
            mdiDownload,
            mdiFilterPlus,
            mdiFilterRemove,
            mdiPencil,
            mdiAccountCancel,
            mdiMagnify,
            filter: {
                acu: {
                    status: false,
                    msu: '',
                    acctN: '',
                    membN: ''
                }
            },
            notif: {
                show: false,
                type: 'success',
                msg: 'Done',
                color: 'success'
            },
            show: {
                disable: {
                    status: false,
                    data: []
                },
                update: {
                    status: false,
                    data: []
                }
            },
            requestType: 'C',
            searchQuery: null,
            search: null,
            loading: false,
            frDate: moment().subtract(5, 'days').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            currentItem: 'tab-AT GLANCE',
            currentDownloadOpanNo: null,
            currentTabForAutoScrollStart: [],
            items: ['AT GLANCE', 'APPROVAL LOGS', 'DISAPPROVAL LOGS', 'LOGIN LIST', 'SUMMARY'],
            headers: [],
            data: [],
            screen_width: document.documentElement.clientWidth + 9
        }
    },
    computed: {
        ...mapGetters(['showProviderApprovalLogsData', 'showProviderDisapprovalLogsData', 'showProviderSummaryData', 'showProviderAtGlanceData', 'showProviderLoginListData', 'downloadReportData', 'downloadApprovalProviderData', 'disableProviderAccountData', 'editProviderAccountData']),
        modifiedHeaders() {
            // Return a new array without the last element
            if (this.currentItem === 'tab-APPROVAL LOGS' || this.currentItem === 'tab-LOGIN LIST' ) {
                return this.headers.slice(0, -1)
            } else {
                return this.headers
            }
        }
    },
    watch: {
        async editProviderAccountData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Account has been updated.'
                    this.notif.show = true
                    this.show.update.status = false
                    await this.showProviderLoginList()
                    let temp = (this.showProviderLoginListData).data ? (this.showProviderLoginListData).data : []
                    this.data  = temp.map(element => {
                        return { ...element, selected: false }
                    })
                } else if (newVal.status === 422) {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        async disableProviderAccountData(newVal) {
            if (newVal && newVal.status === 200) {
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = 'Account has been disabled.'
                this.notif.show = true
                this.show.disable.status = false
                await this.showProviderLoginList()
                let temp = (this.showProviderLoginListData).data ? (this.showProviderLoginListData).data : []
                this.data  = temp.map(element => {
                    return { ...element, selected: false }
                })
            }
        },
        requestType(newVal) {
            this.getData(this.currentItem, { FR_DATE: this.frDate, TO_DATE: this.toDate, TYPE_T: newVal, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN })
        },
        downloadApprovalProviderData(newVal) {
            this.loading = false
            if (newVal && newVal.data)
                this.handleFileDownload(newVal.data, `${this.currentDownloadOpanNo.OPAN_N}-${this.currentDownloadOpanNo.MEMBN}.pdf`)
        },
        downloadReportData(newVal) {
            this.loading = false
            if (newVal && newVal.data)
                this.handleFileDownload(newVal.data, `ProviderPortalReport${this.frDate}--${this.toDate}.xlsx`)
        },
        searchQuery(newVal) {
            if (newVal === '' || newVal === undefined || newVal === null) this.search = ''
        },
        async currentItem(newVal) {
            if (newVal) {
                const params = { FR_DATE: this.frDate, TO_DATE: this.toDate, TYPE_T: this.requestType, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN }
                await this.getData(newVal, params)
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        this.getData(this.currentItem, { FR_DATE: this.frDate, TO_DATE: this.toDate, TYPE_T: this.requestType, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'showProviderApprovalLogs', 'showProviderDisapprovalLogs', 'showProviderSummary', 'showProviderAtGlance', 'showProviderLoginList', 'downloadReport', 'downloadApprovalProvider']),
        onPaginationChange() {
            this.scrollToTop()
        },
        scrollToTop() {
            if (!this.currentTabForAutoScrollStart.includes(this.currentItem)) {
                this.currentTabForAutoScrollStart.push(this.currentItem)
            }
            this.$nextTick(() => {
                let currentIndex = this.currentTabForAutoScrollStart.indexOf(this.currentItem)
                const currentTableRef = `dataTabletest_${currentIndex}`
                if (this.$refs[currentTableRef]) {
                    const tableElement = this.$refs[currentTableRef][0].$el

                    // Try to find the actual table header row
                    const headerRow = tableElement.querySelector('thead tr') ||
                        tableElement.querySelector('.v-data-table-header tr') ||
                        tableElement.querySelector('tr')

                    if (headerRow) {
                        headerRow.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    } else {
                        // Fallback to table element
                        tableElement.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    }
                }
            })
        },
        handleRunFilter(path) {
            // Clear the field manually
            if (path) {
                this.setByPath(this, path, '')
            }
            this.$nextTick(() => {
                const params = { FR_DATE: this.frDate, TO_DATE: this.toDate, TYPE_T: this.requestType, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN }
                this.getData(this.currentItem, params)
            })
        },
        setByPath(obj, path, value) {
            const keys = path.split('.')
            let target = obj
            for (let i = 0; i < keys.length - 1; i++) {
                target = target[keys[i]]
            }
            target[keys[keys.length - 1]] = value
        },
        handleRemoveFilter() {
            this.filter.acu = {
                status: false,
                msu: '',
                acctN: '',
                membN: ''
            }
            this.handleRunFilter()
        },
        UpdateAccountFunc(data) {
            this.show.update.data = structuredClone(data)
            this.show.update.status = true
        },
        disableAccountFunc(data) {
            this.show.disable.data = structuredClone(data)
            this.show.disable.status = true
        },
        downloadOpan(data) {
            this.loading = true
            this.currentDownloadOpanNo = { OPAN_N: data['Approval No.'], MEMBN: data['Member No.'] }
            this.downloadApprovalProvider({ OPAN_N: data['Approval No.'], TYPE_T: this.requestType })
        },
        downloadReportProvider() {
            this.loading = true
            this.downloadReport({ FR_DATE: this.frDate, TO_DATE: this.toDate, TYPE_T: this.requestType, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN })
        },
        // Utility function to handle file download
        handleFileDownload(data, fileName) {
            const blob = base64ToBlob(data.file, data.type)
            const url = URL.createObjectURL(blob)
            saveAs(blob, fileName)
            URL.revokeObjectURL(url) // Clean up the URL object
        },
        async getData(name, params = null) {
            this.headers = []
            this.data = []
            this.loading = true
            let sortable = false
            // await this.getCsrfToken()
            if (name === 'tab-AT GLANCE') {
                await this.showProviderAtGlance(params)
                this.data = [(this.showProviderAtGlanceData).data]
                sortable = false
            } else if (name === 'tab-APPROVAL LOGS') {
                await this.showProviderApprovalLogs(params)
                let temp = (this.showProviderApprovalLogsData).data ? (this.showProviderApprovalLogsData).data : []
                this.data  = temp.map(element => {
                    return { ...element, selected: false }
                })
                sortable = true
            } else if (name === 'tab-DISAPPROVAL LOGS') {
                await this.showProviderDisapprovalLogs(params)
                this.data = (this.showProviderDisapprovalLogsData).data
                sortable = true
            } else if (name === 'tab-LOGIN LIST') {
                await this.showProviderLoginList(params)
                let temp = (this.showProviderLoginListData).data ? (this.showProviderLoginListData).data : []
                this.data  = temp.map(element => {
                    return { ...element, selected: false }
                })
                sortable = true
            } else if (name === 'tab-SUMMARY') {
                await this.showProviderSummary(params)
                this.data = (this.showProviderSummaryData).data
                sortable = true
            }
            this.headers = (this.data).length > 0 ? Object.keys(this.data[0]).map(key => ({
                text: key,
                value: key,
                sortable,
                class: 'headerClassProviderSectionAdminReport'
            })) : []
            this.loading = false
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.providerReportTbl .v-data-table__wrapper {
    overflow-y: auto;
    max-height: 70vh;
}
.approvalTbl > div > table > tbody > tr > td:last-child {
    position: sticky !important;
    position: -webkit-sticky !important;
    right: 0;
    z-index: 1;
    background-color: white;
}
.providerSectionAdminReport h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.providerSectionAdminReport .docInfoBody {
    margin-top: 5%;
    padding: 1% 3% 3% 3%;
}
.headerClassProviderSectionAdminReport {
    text-wrap: nowrap;
}
/* Main container - highly specific selector */
.search-filter-transition-row {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Search column transitions - namespaced */
.search-filter-search-column {
  transition: flex-basis 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
              max-width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: visible;
}

/* Filter columns container - namespaced */
.search-filter-columns-container {
  transition: flex-basis 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
              max-width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

/* .search-filter-columns-container:not(.search-filter-expanded) {
  opacity: 0;
} */

.search-filter-columns-container.search-filter-expanded {
  opacity: 1;
  transition: flex-basis 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
              max-width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
              opacity 0.3s ease-in-out 0.2s;
}

/* Filter row - namespaced */
.search-filter-inner-row {
  height: 100%;
  align-items: center;
}

/* Individual filter field transitions - namespaced */
.search-filter-slide-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.search-filter-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.search-filter-slide-enter {
  opacity: 0;
  transform: translateX(30px) scale(0.9);
}

.search-filter-slide-leave-to {
  opacity: 0;
  transform: translateX(-30px) scale(0.9);
}

/* Staggered delays for filter columns - specific selectors */
.search-filter-field-1 .search-filter-slide-enter-active {
  transition-delay: 0.1s;
}

.search-filter-field-2 .search-filter-slide-enter-active {
  transition-delay: 0.2s;
}

.search-filter-field-3 .search-filter-slide-enter-active {
  transition-delay: 0.3s;
}

.search-filter-field-4 .search-filter-slide-enter-active {
  transition-delay: 0.4s;
}

/* Form field transitions - only affects our specific inputs */
.search-filter-main-input.v-text-field,
.search-filter-field-input.v-text-field {
  transition: all 0.2s ease-in-out;
}

/* Enhanced visual feedback - specific to our component */
.search-filter-compressed .search-filter-main-input.v-text-field {
  transform: scale(0.98);
}

.search-filter-expanded .search-filter-field-input.v-text-field {
  transform: scale(1);
}

/* Loading states - only for our inputs */
.search-filter-main-input.v-text-field--disabled,
.search-filter-field-input.v-text-field--disabled {
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
}

/* Mobile responsiveness - scoped to our component */
@media (max-width: 600px) {
  .search-filter-transition-row {
    flex-direction: column;
  }

  .search-filter-search-column {
    flex-basis: auto !important;
    max-width: 100% !important;
  }

  .search-filter-columns-container {
    flex-basis: auto !important;
    max-width: 100% !important;
    margin-top: 8px;
  }

  .search-filter-field-col {
    flex-basis: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }
}

/* Alternative: Even safer approach using descendant selectors */
.search-filter-transition-row .v-col {
  /* Only affects v-col elements inside our specific row */
}

.search-filter-transition-row .v-text-field {
  /* Only affects v-text-field elements inside our specific row */
}
</style>
